import React from "react";
import "./VoteRadioGroup.scss";

const OPTIONS = [
  { value: "support", label: "Support" },
  { value: "oppose", label: "Oppose" },
  { value: "needs_revisions", label: "Support with amendments" },
  { value: "undecided", label: "Undecided" },
];

const VoteRadioGroup = ({ vote, setVote, voteError, disabled = false }) => {
  return (
    <div className={`vote-radio ${disabled ? "vote-radio--disabled" : ""}`}>
      <p className="vote-radio__label">Your position</p>
      <div className="vote-radio__grid" role="radiogroup" aria-label="Your position on this bill">
        {OPTIONS.map(({ value, label }) => {
          const selected = vote === value;
          return (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              className={[
                "vote-radio__chip",
                selected ? "vote-radio__chip--selected" : "",
                voteError && !vote ? "vote-radio__chip--error" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => setVote(value)}
            >
              <span className="vote-radio__chip-dot" aria-hidden="true" />
              <span className="vote-radio__chip-label">{label}</span>
            </button>
          );
        })}
      </div>

      {voteError && (
        <p className="vote-radio__error-text">Please select a position before posting.</p>
      )}
    </div>
  );
};

export default VoteRadioGroup;
